// extracted by mini-css-extract-plugin
export var quantityInput = "_ew-0";